<template>
    <q-btn-group spread v-if="isGranted('VIEW_POST_ACTIONS')" class="full-width">
        <save-btn v-if="showSave" :post-id="post.id" />
        <escalate-btn v-if="showEscalate" :post="post"/>
        <resolve-btn v-if="showResolve" :post-id="post.id" />
        <resolve-btn v-if="showResolveAndTimeline" :post-id="post.id" move-to-timeline />
        <restore-btn v-if="showRestore" :post-id="post.id" class="full-width" />
        <move-to-timeline-btn v-if="showMoveToTimeline" :post-id="post.id" />
        <remove-from-timeline-btn v-if="showRemoveFromTimeline" :post-id="post.id" />
    </q-btn-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import isGranted from '@/auth/isGranted';
import SaveBtn from '../timeline/SaveBtn.vue';
import EscalateBtn from '../escalate/EscalateBtn.vue';
import ResolveBtn from '../ResolveBtn.vue';
import RestoreBtn from '../RestoreBtn.vue';
import MoveToTimelineBtn from '../timeline/MoveToTimelineBtn.vue';
import RemoveFromTimelineBtn from '../timeline/RemoveFromTimelineBtn.vue';

import {
  isUnreviewed, isSaved,
  isEscalated, isResolved, isOnTimeline,
} from '../post';

export default defineComponent({
  components: {
    SaveBtn,
    EscalateBtn,
    ResolveBtn,
    RestoreBtn,
    MoveToTimelineBtn,
    RemoveFromTimelineBtn,
  },
  props: {
    post: {
      type: Object as () => Post,
      required: true,
    },
  },
  computed: {
    isUnreviewed(): boolean {
      return isUnreviewed(this.post.status);
    },
    isSaved(): boolean {
      return isSaved(this.post.status);
    },
    isEscalated(): boolean {
      return isEscalated(this.post.status);
    },
    isResolved(): boolean {
      return isResolved(this.post.status);
    },
    isTrashed(): boolean {
      return this.post.isTrashed;
    },
    isOnTimeline(): boolean {
      return isOnTimeline(this.post);
    },
    showSave(): boolean {
      return (!this.isTrashed && this.isUnreviewed);
    },
    showEscalate(): boolean {
      return (!this.isTrashed && (this.isUnreviewed || this.isSaved || this.isResolved));
    },
    showResolve(): boolean {
      return (!this.isTrashed && this.isEscalated);
    },
    showResolveAndTimeline(): boolean {
      return (!this.isTrashed && !this.isOnTimeline && this.isEscalated);
    },
    showRestore(): boolean {
      return this.isTrashed;
    },
    showMoveToTimeline(): boolean {
      return (!this.isTrashed && !this.isOnTimeline && this.isResolved);
    },
    showRemoveFromTimeline(): boolean {
      return (!this.isTrashed && this.isOnTimeline);
    },
  },
  methods: {
    isGranted,
  },
});
</script>
